//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Charlson',
  data() {
    return {
      defaultJson:{
        "Leukemia": "白血病",
        "Lymphoma": "淋巴瘤",
        "Dementia": "痴呆",
        "Cerebrovascular Disease": "脑血管疾病",
        "Chronic Pulmonary Disease": "慢性呼吸系统疾病",
        "None": "无",
        "YES": "是",
        "Moderate or Severe Liver Disease": "中重度肝病",
        "AIDS": "AIDS",
        "with OD": "伴脏器受损",
        "Mild Liver Disease": "轻度肝病",
        "Ulcer Disease": "溃疡病",
        "Connective Tissue Disease": "结缔组织病",
        "Chronic Heart Failure": "慢性心衰",
        "Diabetes Mellitus with End Organ Damage": "糖尿病伴终末期器官损伤",
        "Hemiplegia": "偏瘫",
        "Liver Disease": "肝脏疾病",
        "Metastatic Solid Tumor": "转移性实体肿瘤",
        "No": "否",
        "Diabetes Mellitus": "糖尿病",
        "Mod\/Severe": "中重度",
        "NO": "否",
        "Mild": "轻度",
        "Moderate to Severe Renal Disease": "中重度肾脏疾病",
        "Myocardial Infarction": "心肌梗死",
        "Peripheral Vascular Disease": "周围血管疾病",
        "Any Tumor": "任何肿瘤"
      },
      form:{
        chf:'0',
        mi:'0',
        periphVasc:'0',
        cerebroVasc:'0',
        pulmonary:'0',
        ulcer:'0',
        liver:'',
        dm:'',
        renal:'0',
        tumor:'0',
        metastatic:'0',
        leukemia:'0',
        lymphoma:'0',
        aids:'0',
        tissue:'0',
        dementia:'0',
        hemiplegia:'0',
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'无',shortName:'无'},
        {value:"1",name:'轻度肝病',shortName:'轻度'},
        {value:"3",name:'中重度肝病',shortName:'中重度'},
      ],
      dataList2:[
        {value:"0",name:'否',shortName:'否'},
        {value:"1",name:'糖尿病',shortName:'是'},
        {value:"2",name:'糖尿病伴终末期器官损伤',shortName:'伴脏器受损'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
      // chf+mi+periphVasc+cerebroVasc+pulmonary+liver+ulcer+dm+renal*2+tumor*2+metastatic*6+leukemia*2+lymphoma*2+aids*6+tissue+dementia+hemiplegia*2
        let result = form.chf+form.mi+form.periphVasc+form.cerebroVasc+form.pulmonary+form.liver+form.ulcer+form.dm+form.renal*2+form.tumor*2+form.metastatic*6+form.leukemia*2+form.lymphoma*2+form.aids*6+form.tissue+form.dementia+form.hemiplegia*2
        	
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/Charlson.vue